"use client"

import { useTranslations } from "next-intl"
import { type HTMLAttributes, useState } from "react"
import { Section } from "@/app/[locale]/_components/sections/section"
import { config } from "@/config"
import { Entitlement } from "@/lib/polar/types"
import { cn } from "@/utils/cn"
import { AffiliateProgramBanner } from "./affiliate-program-banner"
import { CouponCodeButton } from "./coupon-code-button"
import { PricingPlanItem } from "./pricing-plan-item"
import { RecurringIntervalToggle } from "./recurring-interval-toggle"
import { TestimonialAvatars } from "./testimonial-avatars"

interface SubscriptionsPricingProps extends HTMLAttributes<HTMLDivElement> {
  mode?: "page" | "app"
}

export function SubscriptionsPricingSection({
  mode = "page",
  className,
  ...props
}: SubscriptionsPricingProps) {
  const [recurringInterval, setRecurringInterval] = useState<"month" | "year">("month")
  const t = useTranslations()

  const handleTabChange = (tab: "month" | "year") => {
    setRecurringInterval(tab)
  }

  return (
    <>
      <div
        className={cn("mx-auto flex justify-center gap-3 pb-8", mode === "app" ? "pt-8" : "pt-16")}
      >
        <TestimonialAvatars />

        <CouponCodeButton />
      </div>

      <Section
        id="pricing"
        title={t("Pricing.title")}
        description={t("Pricing.description")}
        className={cn("!pt-0 !gap-y-12", mode === "app" && "!pb-8")}
      >
        <div className="-mt-2 flex flex-col-reverse items-center justify-center gap-x-3 gap-y-6 sm:flex-row">
          <RecurringIntervalToggle value={recurringInterval} onValueChange={handleTabChange} />

          {/* <DemoVideoButton /> */}
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:gap-6">
          <PricingPlanItem
            plan={config.pricing[Entitlement.PRO]}
            interval={recurringInterval}
            mode={mode}
          />
          <PricingPlanItem
            plan={config.pricing[Entitlement.ULTRA]}
            interval={recurringInterval}
            mode={mode}
          />
          <PricingPlanItem
            plan={config.pricing[Entitlement.ENTERPRISE]}
            interval={recurringInterval}
            mode={mode}
            className="md:col-span-2 lg:col-span-1"
          />
        </div>

        <AffiliateProgramBanner />
      </Section>
    </>
  )
}
